<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    표-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-not-dot-in-label="true"
      title="경비업무"
      tableHeaderTitle="점검항목"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from '@/components/TableInspect'

export default {
  components: {
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        inspectList_1: [
          {
            id: 1,
            label: "1. 랜턴, 야광조끼, 야광봉, 안전화 등 챙겼는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 계단을 오르내릴땐 손잡이를 잡는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 주머니에 손을 넣고 경사, 결빙, 어두운 곳을 순찰하지 않는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 흡연하면서 작업하거나 근무 중 음주하지 않는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. 통로는 충분히 밝은가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. 통로는 정리정돈 되어 걸려 넘어질 위험이 없는가?",
            is_checked: "",
          },
          {
            id: 7,
            label: "7. 계단은 파손부위가 없고 미끄럼방지 조치를 하였는가?",
            is_checked: "",
          },
          {
            id: 8,
            label: "8. 경비책임자가 주기적으로 현장을 점검하는가?",
            is_checked: "",
          },
          {
            id: 9,
            label: "9. 현장 점검결과 문제점은 빠른 시일 내에 해결하는가?",
            is_checked: "",
          },
          {
            id: 10,
            label: "10. 비상연락망이 게시되어 있는가?",
            is_checked: "",
          },
          {
            id: 11,
            label: "11. 소화기 및 소화전의 작동 및 사용방법을 아는가?",
            is_checked: "",
          },
          {
            id: 12,
            label: "12. 화재발생 시 소방 및 대피방법을 알고 있는가?",
            is_checked: "",
          },
          {
            id: 13,
            label: "13. 무거운 물체 운반 시 2인 1조로 작업을 실시하는가?",
            is_checked: "",
          },
          {
            id: 14,
            label: "14. 올바른 중량물 취급방법에 대해 알고 있는가?",
            is_checked: "",
          },
          {
            id: 15,
            label: "15. 작업 전, 중, 후 주기적으로 스트레칭을 하는가?",
            is_checked: "",
          },

        ],
      },
    };
  },
  methods: {
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
  },
};
</script>

<style scoped lang="scss">
</style>
